<ion-content role="feed" scroll-y="true">
  <div class="widget-container">
    <ion-grid>
      <ion-row class="close-row">
        <ion-col (click)="close()" class="close-col" id="roadmap_cancel_button">
          <img src="../../../assets/icon/cancel.svg" alt="">
        </ion-col>
      </ion-row>
      <ion-row class="header-row">
        <ion-col size="8">
          <div class="ion-text-start header-title">
            {{"Select Machines" | translate}}
          </div>
        </ion-col>
      </ion-row>

      <ion-row style="margin-left: 3rem;">
        <ion-col size="6" size-sm='6' size-md="6" size-lg="6" size-xl="6" size-xs='12' *ngFor="let item of selectedMachines">
          <ion-item style="--background: none;" lines="none">
            <ion-checkbox [(ngModel)]="item.isChecked" style="margin-right: 20px;"
              class="col-checkbox" id="machine_checkbox_{{item.machineId}}"
              [ngClass]="item.disabled ? 'disabled-checkbox' : ''" (ionChange)="changeRoadmapCheckedValue()">
            </ion-checkbox>
            <ion-label class="content-card-title" id="roadmap_title_{{item.machineId}}"
              [ngClass]="item.disabled ? 'disabled-class-title' : ''">
              {{item.machine_name}} </ion-label>
          </ion-item>
        </ion-col>
      </ion-row>


      <ion-row class="button-row">
        <button ion-button position="bottom" [disabled]="!isAnyValueChanged" id="roadmap_save_button"
          [ngClass]="!isAnyValueChanged ? 'disable-button' : 'active-button'" (click)="saveSelectedMachineInfo()">
          {{'Save'|translate}}
        </button>
      </ion-row>
    </ion-grid>
  </div>

</ion-content>